/**
 * AP-36 — Feldpfade wie `monthlyReportConfig.hoursFormat`. Der Server führt
 * solche JSON-Spalten einen Schlüssel tief zusammen (Anhang A, 8.4); die Maske
 * sendet deshalb nur `{ monthlyReportConfig: { hoursFormat } }`.
 */
import type { Datensatz } from './stelle'

/** Wert an einem Pfad (`a.b`) — `undefined`, wenn unterwegs etwas fehlt. */
export function wertAn(daten: Datensatz | undefined, pfad: string): unknown {
  let wert: unknown = daten
  for (const teil of pfad.split('.')) {
    if (wert === null || typeof wert !== 'object') return undefined
    wert = (wert as Datensatz)[teil]
  }
  return wert
}

/** `{ a: { b: wert } }` aus `a.b`. */
export function pfadPatch(pfad: string, wert: unknown): Datensatz {
  const teile = pfad.split('.')
  let patch: unknown = wert
  for (let i = teile.length - 1; i >= 0; i--) patch = { [teile[i]]: patch }
  return patch as Datensatz
}

const istObjekt = (v: unknown): v is Datensatz => v !== null && typeof v === 'object' && !Array.isArray(v)

/** Patches zusammenführen, verschachtelte Objekte rekursiv (zwei Pfade derselben Spalte in einer Gruppe). */
export function fuegeZusammen(ziel: Datensatz, quelle: Datensatz): Datensatz {
  const ergebnis: Datensatz = { ...ziel }
  for (const [k, v] of Object.entries(quelle)) {
    ergebnis[k] = istObjekt(v) && istObjekt(ergebnis[k]) ? fuegeZusammen(ergebnis[k] as Datensatz, v) : v
  }
  return ergebnis
}
